module.exports = __webpack_public_path__ + "assets/img/26_826.74bce427.jpg";